import script from "./DashboardProductsStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardProductsStatistics.vue?vue&type=script&setup=true&lang=js"

import "./DashboardProductsStatistics.vue?vue&type=style&index=0&id=b9f61b2c&lang=css"

const __exports__ = script;

export default __exports__